export default __webpack_public_path__ + "849f16ad6d311e0bb884863c9fb8b287.png";